import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { useContext } from 'react';
import { ACTIONS, SCREENS } from '../../../constants/Tracking';
import { associationTypesToCall, objectTypes } from '../../../constants/types';
import { ContactsPropsContext } from '../../../contexts/contacts/PropsContext';
import { ContactsContext } from '../../../contexts/contacts/context';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DissociateGuestModal({
  setContactToDissociate,
  contactToDissociate,
  appName,
  getAssociations
}) {
  const {
    usageTracker,
    callObjectTitle,
    callObjectId
  } = useContext(ContactsPropsContext);
  const {
    contactsActions
  } = useContext(ContactsContext);
  const dissociateContact = () => {
    usageTracker.trackInteraction(Object.assign({
      screen: SCREENS.participants
    }, ACTIONS.participants.clickDissociateConfirm));
    contactsActions.disassociateObject({
      associationType: associationTypesToCall[objectTypes.contacts],
      objectType: objectTypes.contacts,
      toObjectId: callObjectId,
      objectId: contactToDissociate.contactId.toString(),
      cb: getAssociations
    });
    setContactToDissociate(null);
  };
  const cancelHandler = () => {
    usageTracker.trackInteraction(Object.assign({
      screen: SCREENS.participants
    }, ACTIONS.participants.clickDissociateCancel));
    setContactToDissociate(null);
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": `${appName}-associations-popup-modal`,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contactList.guestDialogPopup.header"
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "contactList.guestDialogPopup.body",
        options: {
          hubspotContactName: `${contactToDissociate.firstname} ${contactToDissociate.lastname}`,
          callObjectTitle
        }
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: dissociateContact,
        "data-test-id": `${appName}-guest-dissociate-confirm-button`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contactList.guestDialogPopup.unmap"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: cancelHandler,
        "data-test-id": `${appName}-guest-dissociate-cancel-button`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contactList.guestDialogPopup.cancel"
        })
      })]
    })]
  });
}
export default DissociateGuestModal;